export const ExecutionsAttempsTableConstants = {
    header: "Execution attempts"
}